export const API_HOST = process.env.REACT_APP_API_HOST;
export const STATIC_HOST = process.env.REACT_APP_STATIC_HOST;
export const PORTAL_ID = process.env.REACT_APP_PORTAL_ID;
export const LOCALE = process.env.REACT_APP_LOCALE;
